import * as moment from "moment";
import { Component } from "vue-property-decorator";
import { DemandeRecuperationAbsencesFuturesDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeRecuperationAbsencesFuturesDto";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { SalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { SortieSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SortieSalarieDto";
import formulaireEntreeSortieHelper from "../../Helper/formulaireEntreeSortieHelper";
import numberHelper from "../../Helper/numberHelper";
import stringHelper from "../../Helper/stringHelper";
import Form from "../../shared/components/forms/Form";
import VerticalScroll from "../../shared/components/VerticalScroll/vertical-scroll";
import { KeyValue } from "../../shared/models/Input";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import ModalAbsencesFuturesFinDeContrat from "../modalComponents/modalAbsencesFuturesFinDeContrat/modalAbsencesFuturesFinDeContrat";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import { DataForm, dataFormBase, listeBooleenBase, listeMotifLicenciementBase, listeReglementBase } from "./sortieSalarie.model";
import { HoraireHebdoDto } from "../../dto/GenApi.iNotPaie.Dto/HoraireHebdoDto";
import dateHelper from "../../Helper/dateHelper";
import {
	decimalHeuresEnMinutes,
	formatMinutesAsHHmm,
	horairesHebdoSontRenseignes,
	normaliserHoraireHebdoRecu,
	libelleAffichageHorairesPresence,
	totalMinutesHoraireHebdo,
} from "../../Helper/horaireHebdoHelper";

interface sortiesSalarieChargeInfos {
	isModified: boolean;
	dataForm: DataForm;
	readOnly: boolean;
	sortieSalarie: SortieSalarieDto;
}

@Component({
	beforeRouteEnter(to, from, next) {
		if ((Number(to.params.id) == 0 && !ParametresInstance.userHasRole(RoleConstants.UtilisateurPST)) || (!to.query || to.query.titre == null)) {
			next(false);

			return;
		}
		next(v => {
			const vm = (v as SortieSalarieComponent);
			vm.Init();
		});
	},
	beforeRouteUpdate(to, from, next) {
		if ((Number(to.params.id) == 0 && !ParametresInstance.userHasRole(RoleConstants.UtilisateurPST)) || (!to.query || to.query.titre == null)) {
			next(false);

			return;
		}

		const _this = (this as SortieSalarieComponent);
		_this.saveState(Number(from.params.id));
		next();
		_this.Init();
	},
	beforeRouteLeave(to, from, next) {
		const _this = (this as SortieSalarieComponent);
		if (!_this.disableBeforeRouteLeave) {
			_this.saveState(Number(from.params.id));
		}
		next();
	},
	components: {
		ModalAbsencesFuturesFinDeContrat: require("../modalComponents/modalAbsencesFuturesFinDeContrat/modalAbsencesFuturesFinDeContrat.vue.html"),
		ModalHoraireHebdo: require("../modalComponents/modalHoraireHebdo/modalHoraireHebdo.vue.html"),
	}
})
export default class SortieSalarieComponent extends VueBase {
	public scrollFormSortieSalarie = <VerticalScroll> this.$refs.scrollFormSortieSalarie;
	public formSortieSalarie = <Form> this.$refs.formSortieSalarie;

	public dataReady = false;
	public initData = false;

	public isAdminPst = false;
	public isUtilisateurPst = false;
	public disableBeforeRouteLeave = false

	public dataForm: DataForm = this.copy(dataFormBase);

	public listeSalarie: SalarieDto[] = [];
	public listeMotifsDepart: ParametreDto[] = [];
	public listeReglement = listeReglementBase;
	public listeBooleen = listeBooleenBase;
	public listeMotif: ParametreDto[] = [];
	public listeTypesPreavis: ParametreDto[] = [];

	public showHorairesPresenceAlerte = false;
	public hasHorairesError = false;
	public horairesPresenceLibelle: string = "À renseigner";
	public horaireHebdo: HoraireHebdoDto | undefined = undefined;
	public showModalHoraireHebdo = false;
	public libelleHeuresPourModale: string | undefined = undefined;
	public horaireHebdoPourModale: HoraireHebdoDto | undefined = undefined;
	public heuresMensuellesContrat: number | undefined = undefined

	public amountLoading = 0;

	public listeMotifLicenciement = listeMotifLicenciementBase;

	public currentId = 0;
	public readOnly = false;

	public modalAbsencesFuturesFinDeContrat?: ModalAbsencesFuturesFinDeContrat;

	public sortieSalarie: SortieSalarieDto = {
		Id: 0,
		IdSalarie: 0,
		DateCreation: new Date(),
		DateModification: new Date(),
		EstValidee: false,
		EstSoumise: false,
		ModeReglement: 1,
		DebutPreavis: new Date(),
		FinPreavis: new Date(),
		DebutLicenciement: new Date(),
		SignatureCERFA: new Date(),
		CPAPayer: 0,
		RTTAPayer: 0,
		IndemniteCDD: false,
		IndemniteTreiziemeMois: false,
		DateNotificationRupture: new Date(),
		DateDepart: new Date(),
		DateDernierJour: new Date()
	};

	public sortieSalarieChargees: Record<number, sortiesSalarieChargeInfos> = {};

	public mounted(): void {
		EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
			if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined && this.sortieSalarie != undefined) {
				ServicesFactoryInstance.SalarieService.getSalariesEnCours(data => {
					this.listeSalarie = data.sort(this.sortByFullName);
					this.checkListReady();
				});
			}
		});

		EventBus.$on(EventConstants.TAB_CLOSED, e => {
			if (e.path.includes("/sortieSalarie/")) {
				this.removeState(Number(e.params.id));
			}
		});
	}

	public Init(): void {
		this.disableBeforeRouteLeave = false;
		this.dataReady = false;
		this.initData = false;
		this.currentId = Number(this.$route.params.id);
		this.hasHorairesError = false;
		this.showModalHoraireHebdo = false;
		this.horaireHebdo = undefined
		this.majAffichageHorairesPresence();

		const currentSalarieChargee = this.sortieSalarieChargees[this.currentId];

		if (currentSalarieChargee != undefined) {
			this.dataForm = this.copy(currentSalarieChargee.dataForm);
			this.isModified = currentSalarieChargee.isModified;
			this.readOnly = currentSalarieChargee.readOnly;
			this.sortieSalarie = this.copy(currentSalarieChargee.sortieSalarie);
			this.retrieveSalarieInfo();

			this.initData = true;
		} else {
			this.dataForm = this.copy(dataFormBase);
			this.clearSortieSalarie();
			this.formSortieSalarie = <Form> this.$refs.formSortieSalarie;
			this.formSortieSalarie.resetState();
			this.formSortieSalarie.clear();
			this.initConstantes();
		}
	}

	// Permet de sauvegarder l'état de l'onglet pour le recharger si on revient dessus
	public saveState(id: number): void {
		if (this.sortieSalarie?.Id === this.currentId) {
			this.sortieSalarieChargees[id] = {
				isModified: this.isModified,
				dataForm: this.copy(this.dataForm),
				readOnly: this.readOnly,
				sortieSalarie: this.copy(this.sortieSalarie)
			};
		}
	}

	// Permet de supprimer une sauvegarde d'état de l'onglet
	public removeState(id: number): void {
		if (this.sortieSalarieChargees[id]) {
			delete this.sortieSalarieChargees[id];
		}
	}

	private sortByFullName(a: SalarieDto, b: SalarieDto) {
		if (a.FullName == undefined || b.FullName == undefined) {
			return 0;
		}
		if (a.FullName < b.FullName) {
			return -1;
		}
		if (a.FullName > b.FullName) {
			return 1;
		}

		return 0;
	}

	// Permet de faire une copie d'un élément
	private copy(data): any {
		const copied = JSON.parse(JSON.stringify(data));

		return copied;
	}

	// Permet de nettoyer sortieSalarie
	private clearSortieSalarie(): void {
		this.sortieSalarie = {
			Id: 0,
			IdSalarie: 0,
			DateCreation: new Date(),
			DateModification: new Date(),
			EstValidee: false,
			EstSoumise: false,
			ModeReglement: 1,
			DebutPreavis: new Date(),
			FinPreavis: new Date(),
			DebutLicenciement: new Date(),
			SignatureCERFA: new Date(),
			CPAPayer: 0,
			RTTAPayer: 0,
			IndemniteCDD: false,
			IndemniteTreiziemeMois: false,
			DateNotificationRupture: new Date(),
			DateDepart: new Date(),
			DateDernierJour: new Date()
		};
	}

	public initConstantes(): void {
		this.amountLoading = 4;

		ServicesFactoryInstance.ParametresService.getMotifRuptures(data => {
			this.listeMotif = data;
			this.amountLoading--;
			this.checkListReady();
		});

		ServicesFactoryInstance.ParametresService.getTypesPreavis(data => {
			this.listeTypesPreavis = data;
			this.amountLoading--;
			this.checkListReady();
		});

		ServicesFactoryInstance.ParametresService.getMotifDeparts(false, data => {
			this.listeMotifsDepart = data;
			this.amountLoading--;
			this.checkListReady();
		});

		ServicesFactoryInstance.SalarieService.getSalariesEnCours(data => {
			this.listeSalarie = data.sort(this.sortByFullName);
			this.amountLoading--;
			this.checkListReady();
		});
		
	}

	private checkListReady(): void {
		if (this.amountLoading > 0) {
			return;
		}

		if (!this.initData) {
			this.initData = true;

			this.isAdminPst = ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);
			this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);

			if (this.currentId !== 0) {
				this.dataReady = false;
				ServicesFactoryInstance.SortieSalarieService.getSortieSalarie(this.currentId, data => {
					this.sortieSalarie = data;

					this.setReadOnly();

					if (this.readOnly) {
						for (const data in this.dataForm) {
							this.dataForm[data].disabled = true;
						}
					} else {
						for (const data in this.dataForm) {
							this.dataForm[data].disabled = false;
						}
					}

					this.commonSetDataForm();

					if (this.readOnly) {
						this.setDataFormForReadOnly();
					} else {
						this.setDataFormForUpdateOrCreate();
					}

					this.isModified = false;
					this.toggleMotif();
					this.togglePreavis();
					this.retrieveSalarieInfo();
					this.$forceUpdate();
				}, () => {
					// Ferme l'onglet si l'appel est rejeté
					EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
				});
			} else {
				this.setDataFormDefault();
				this.setReadOnly();
				this.isModified = false;

				setTimeout(() => {
					this.formSortieSalarie = <Form> this.$refs.formSortieSalarie;
					this.formSortieSalarie.resetState();
					this.dataReady = true;
				}, 1);
			}
		}
	}

	// Permet d'assigner la valeur du formulaire de sortie aux inputs d'une autre façon pour le cas de la visualisation
	private setDataFormForReadOnly(): void {
		this.dataForm.salarie.vmodel = this.sortieSalarie.FullName ? this.sortieSalarie.FullName : "";
	}

	// Permet d'assigner la valeur du formulaire de sortie aux inputs d'une autre façon pour le cas d'une création ou modification
	private setDataFormForUpdateOrCreate(): void {
		this.dataForm.salarie.vmodel = this.sortieSalarie.IdSalarie ? this.sortieSalarie.IdSalarie.toString() : "";
	}

	// Permet d'assigner la valeur du formulaire de sortie aux inputs
	private commonSetDataForm(): void {
		this.dataForm.heuresmois.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.HeuresTravailleesMois);
		this.dataForm.transport.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.RemboursementTransport);
		this.dataForm.restaurant.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.TitresRestaurant);
		this.dataForm.cprestant.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.CPAPayer);
		this.dataForm.rttrestant.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.RTTAPayer);
		this.dataForm.reglement.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.ModeReglement);
		this.dataForm.dateDepart.vmodel = this.sortieSalarie.DateDepart ? moment(this.sortieSalarie.DateDepart).format("YYYY-MM-DD") : "";
		this.dataForm.dateDernier.vmodel = this.sortieSalarie.DateDernierJour ? moment(this.sortieSalarie.DateDernierJour).format("YYYY-MM-DD") : "";
		this.dataForm.dateNotif.vmodel = this.sortieSalarie.DateNotificationRupture ? moment(this.sortieSalarie.DateNotificationRupture).format("YYYY-MM-DD") : "";
		this.dataForm.refusCdiSuiteCdd.vmodel = this.sortieSalarie.RefusCdiSuiteCdd ? "1" : "0";
		this.dataForm.motif.vmodel = this.sortieSalarie.MotifDepart ? this.sortieSalarie.MotifDepart : "";
		this.dataForm.divers.vmodel = this.sortieSalarie.AutresInformations ? this.sortieSalarie.AutresInformations : "";

		this.dataForm.motifLicenciement.vmodel = this.sortieSalarie.MotifLicenciement ? this.sortieSalarie.MotifLicenciement : "";
		this.dataForm.dateLicenciement.vmodel = this.sortieSalarie.DebutLicenciement ? moment(this.sortieSalarie.DebutLicenciement).format("YYYY-MM-DD") : "";
		this.dataForm.typePreavis.vmodel = this.sortieSalarie.TypePreavis ? this.sortieSalarie.TypePreavis : "";
		this.dataForm.debutPreavis.vmodel = this.sortieSalarie.DebutPreavis ? moment(this.sortieSalarie.DebutPreavis).format("YYYY-MM-DD") : "";
		this.dataForm.finPreavis.vmodel = this.sortieSalarie.FinPreavis ? moment(this.sortieSalarie.FinPreavis).format("YYYY-MM-DD") : "";
		this.dataForm.montantIndemnite.vmodel = stringHelper.convertNumberOrUndefinedToString(this.sortieSalarie.MontantRuptureConcentionnelle);
		this.dataForm.dateSignature.vmodel = this.sortieSalarie.SignatureCERFA ? moment(this.sortieSalarie.SignatureCERFA).format("YYYY-MM-DD") : "";
		this.dataForm.autreMotif.vmodel = this.sortieSalarie.AutresMotifs ? this.sortieSalarie.AutresMotifs : "";

		this.setMotifDeDepartRequired();
		this.setRefusCdiSuiteCddRequired();
	}

	public transformList(list: ParametreDto[]): KeyValue[] {
		const finalList: KeyValue[] = [];

		for (let i = 0; i < list.length; i++) {
			finalList.push({
				key: list[i].Code!,
				value: list[i].Libelle!
			});
		}

		return finalList;
	}

	public transformListSalarie(list: SalarieDto[]): KeyValue[] {
		const finalList: KeyValue[] = [];

		for (let i = 0; i < list.length; i++) {
			finalList.push({
				key: list[i].Id.toString(),
				value: list[i].FullName ?? ""
			});
		}

		return finalList;
	}

	public changed(type: string): void {
		this.isModified = true;

		if (type !== undefined) {
			switch (type) {
				case "motif":
					this.toggleMotif();
					break;
				case "typePreavis":
					this.togglePreavis();
					break;
				case "autreMotif":
				case "motifLicenciement":
					this.setMotifDeDepartRequired();
					break;
				case "salarie":
					this.setRefusCdiSuiteCddRequired();
					this.retrieveSalarieInfo();
					break;
			}
		}
	}

	public togglePreavis(): void {
		if (this.dataForm.typePreavis.vmodel === "" || this.dataForm.typePreavis.vmodel === "PASPR") {
			this.dataForm.debutPreavis.disabled = true;
			this.dataForm.finPreavis.disabled = true;
		} else {
			this.dataForm.debutPreavis.disabled = this.readOnly;
			this.dataForm.finPreavis.disabled = this.readOnly;
		}
	}

	public toggleMotif(): void {
		// DISABLED

		this.dataForm.motifLicenciement.disabled = true;
		this.dataForm.dateLicenciement.disabled = true;

		this.dataForm.typePreavis.disabled = true;
		this.dataForm.debutPreavis.disabled = true;
		this.dataForm.finPreavis.disabled = true;

		this.dataForm.montantIndemnite.disabled = true;
		this.dataForm.dateSignature.disabled = true;

		this.dataForm.autreMotif.disabled = true;

		// VMODEL

		if (this.currentId === 0 || this.currentId !== 0 && this.isModified) {
			this.dataForm.motifLicenciement.vmodel = "";
			this.dataForm.dateLicenciement.vmodel = "";

			this.dataForm.typePreavis.vmodel = "";
			this.dataForm.debutPreavis.vmodel = "";
			this.dataForm.finPreavis.vmodel = "";

			this.dataForm.montantIndemnite.vmodel = "";
			this.dataForm.dateSignature.vmodel = "";

			this.dataForm.autreMotif.vmodel = "";
		}

		// DISPLAY

		if (this.currentId === 0 || this.currentId !== 0 && this.isModified) {
			this.dataForm.motifLicenciement.display = "";
			this.dataForm.dateLicenciement.display = "";

			this.dataForm.typePreavis.display = "";
			this.dataForm.debutPreavis.display = "";
			this.dataForm.finPreavis.display = "";

			this.dataForm.montantIndemnite.display = "";
			this.dataForm.dateSignature.display = "";

			this.dataForm.autreMotif.display = "";
		}

		// ENABLE / DISABLE

		if (this.dataForm.motif.vmodel === "010") {
			this.dataForm.typePreavis.disabled = this.readOnly;
			this.dataForm.debutPreavis.disabled = this.readOnly;
			this.dataForm.finPreavis.disabled = this.readOnly;
		}

		if (this.dataForm.motif.vmodel === "012") {
			this.dataForm.typePreavis.disabled = this.readOnly;
			this.dataForm.debutPreavis.disabled = this.readOnly;
			this.dataForm.finPreavis.disabled = this.readOnly;

			this.dataForm.motifLicenciement.disabled = this.readOnly;
			this.dataForm.dateLicenciement.disabled = this.readOnly;
		}

		if (this.dataForm.motif.vmodel === "138") {
			this.dataForm.montantIndemnite.disabled = this.readOnly;
			this.dataForm.dateSignature.disabled = this.readOnly;
		}

		if (this.dataForm.motif.vmodel === "903") {
			this.dataForm.autreMotif.disabled = this.readOnly;
		} else {
			this.dataForm.autreMotif.disabled = true;
		}

		this.setMotifDeDepartRequired();
	}

	public saveButton(): void {
		if (!this.isValidHorairesPresence()) return;
		this.formSortieSalarie = <Form> this.$refs.formSortieSalarie;
		this.formSortieSalarie.trigger();

		setTimeout(() => {
			if (this.formSortieSalarie.checkSuccess()) {
				this.dataReady = false;
				this.setFormDataToSortieSalarie();

				if (this.sortieSalarie !== undefined) {
					if (this.sortieSalarie.Id <= 0) { // Un Ajout
						ServicesFactoryInstance.SortieSalarieService.addSortieSalarie(this.sortieSalarie, data => {
							if (this.sortieSalarie !== undefined) {
								this.sortieSalarie.Id = data.Id;
								this.currentId = data.Id;
							}

							this.saveHoraireHebdo();
							this.afterSend(true, true);
						}, () => this.dataReady = true);
					} else { // Une MAJ
						ServicesFactoryInstance.SortieSalarieService.updateSortieSalarie(this.sortieSalarie, () => {
							this.saveHoraireHebdo();
							this.afterSend(false, true);
						}, () => this.dataReady = true);
					}
				}
			} else {
				NotificationServiceInstance.SendFailed("Des erreurs sont présentes dans le formulaire.");
			}
		}, 1);
	}

	public setFormDataToSortieSalarie(): void {
		if (this.sortieSalarie !== undefined) {
			this.sortieSalarie.Id = this.currentId;
			if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
				this.sortieSalarie.CodeSociete = ParametresInstance.societeCourante.Code;
			}
			this.sortieSalarie.IdSalarie = Number(this.dataForm.salarie.vmodel);
			this.sortieSalarie.FullName = this.dataForm.salarie.display;
			this.sortieSalarie.HeuresTravailleesMois = numberHelper.convertToNumberOrUndefined(this.dataForm.heuresmois.vmodel);
			this.sortieSalarie.RemboursementTransport = numberHelper.convertToNumberOrUndefined(this.dataForm.transport.vmodel);
			this.sortieSalarie.TitresRestaurant = numberHelper.convertToNumberOrUndefined(this.dataForm.restaurant.vmodel);
			this.sortieSalarie.CPAPayer = numberHelper.convertToNumberOrUndefined(this.dataForm.cprestant.vmodel);
			this.sortieSalarie.RTTAPayer = numberHelper.convertToNumberOrUndefined(this.dataForm.rttrestant.vmodel);
			this.sortieSalarie.ModeReglement = numberHelper.convertToNumberOrUndefined(this.dataForm.reglement.vmodel);
			this.sortieSalarie.DateDepart = moment.utc(this.dataForm.dateDepart.vmodel).toDate();
			this.sortieSalarie.DateDernierJour = moment.utc(this.dataForm.dateDernier.vmodel).toDate();
			this.sortieSalarie.DateNotificationRupture = moment.utc(this.dataForm.dateNotif.vmodel).toDate();
			this.sortieSalarie.RefusCdiSuiteCdd = this.dataForm.refusCdiSuiteCdd.vmodel === "1";
			this.sortieSalarie.MotifDepart = this.dataForm.motif.vmodel;
			this.sortieSalarie.AutresInformations = this.dataForm.divers.vmodel;

			// Si on a choisi "rupture conventionnelle" il faut aussi le mettre dans le motif de licenciement
			if (this.dataForm.motif.vmodel === "138") {
				this.sortieSalarie.MotifLicenciement = "43";
			} else {
				this.sortieSalarie.MotifLicenciement = this.dataForm.motifLicenciement.vmodel;
			}
			this.sortieSalarie.DebutLicenciement = moment.utc(this.dataForm.dateLicenciement.vmodel).toDate();
			this.sortieSalarie.TypePreavis = this.dataForm.typePreavis.vmodel;
			this.sortieSalarie.DebutPreavis = moment.utc(this.dataForm.debutPreavis.vmodel).toDate();
			this.sortieSalarie.FinPreavis = moment.utc(this.dataForm.finPreavis.vmodel).toDate();
			this.sortieSalarie.MontantRuptureConcentionnelle = numberHelper.convertToNumberOrUndefined(this.dataForm.montantIndemnite.vmodel);
			this.sortieSalarie.SignatureCERFA = moment.utc(this.dataForm.dateSignature.vmodel).toDate();
			this.sortieSalarie.AutresMotifs = this.dataForm.autreMotif.vmodel;
		}
	}

	private afterSend(isAdd: boolean, showNotif: boolean): void {
		this.dataReady = true;

		this.removeState(this.currentId);
		this.disableBeforeRouteLeave = true;

		this.formSortieSalarie = <Form> this.$refs.formSortieSalarie;
		this.formSortieSalarie.resetState();
		this.formSortieSalarie.clear();

		if (showNotif) {
			if (isAdd) {
				NotificationServiceInstance.SendSuccess("Demande de sortie de salarié créée avec succès.");
			} else {
				NotificationServiceInstance.SendSuccess("Modification de la sortie du salarié effectuée avec succès.");
			}
		}

		EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
		EventBus.NavigateTo({
			path: "/listeSortiesSalarie/"
		});
	}

	public cancelButton(): void {
		if (this.isModified) {
			const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
				message: "Souhaitez-vous vraiment annuler ? Les modifications non sauvegardées seront perdues !",
				callBackYes: () :void => {
					this.afterSend(false, false);
				}
			});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
		} else {
			this.afterSend(false, false);
		}
	}

	public validate(): void {
		if (!this.isValidHorairesPresence()) return;
		this.formSortieSalarie.trigger();

		setTimeout(() => {
			if (this.formSortieSalarie.checkSuccess()) {
				const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
					message: "Souhaitez-vous vraiment valider cette sortie ?",
					callBackYes: () => {
						this.dataReady = false;

						this.setFormDataToSortieSalarie();

						if (this.sortieSalarie !== undefined) {
							if (this.sortieSalarie.Id <= 0) { // Un Ajout
								ServicesFactoryInstance.SortieSalarieService.addSortieSalarie(this.sortieSalarie, data => {
									if (this.sortieSalarie !== undefined) {
										this.sortieSalarie.Id = data.Id;
										this.currentId = data.Id;
									}

									this.saveHoraireHebdo();
									this.valideEmploye();
								}, () => this.dataReady = true);
							} else { // Une MAJ
								ServicesFactoryInstance.SortieSalarieService.updateSortieSalarie(this.sortieSalarie, () => {
									this.saveHoraireHebdo();
									this.valideEmploye();
								}, () => this.dataReady = true);
							}
						}
					}
				});

				EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
			} else {
				NotificationServiceInstance.SendFailed("Le formulaire n'a pas pu être validé. Veuillez renseigner tous les champs obligatoires.");
				this.dataReady = true;
			}
		}, 1);
	}

	public valideEmploye(): void {
		ServicesFactoryInstance.SortieSalarieService.valideEmployeExit(this.currentId, data => {
			let titreOnglet = "Sortie ";
			if (this.sortieSalarie != undefined) {
				titreOnglet += this.sortieSalarie.FullName;
			}
			NotificationServiceInstance.SendSuccess("Sortie de salarié validée avec succès.");

			if (data != null) {
				this.checkAbsencesFuturesFinDeContrat(data.IdContrat, data.IdSalarie, titreOnglet);
			} else {
				this.openFicheSalarie(data, titreOnglet);
			}
		}, () => this.dataReady = true);
	}

	private checkAbsencesFuturesFinDeContrat(idContrat: number, idSalarie, titreOnglet: string): void {
		if (this.sortieSalarie.DateDepart == undefined) {
			return;
		}

		const demande: DemandeRecuperationAbsencesFuturesDto = {
			IdContrat: idContrat,
			DateMax: this.sortieSalarie.DateDepart
		};

		ServicesFactoryInstance.AbsencesService.getAbsencesFuturesByContrat(demande, data => {
			this.modalAbsencesFuturesFinDeContrat = this.$refs.modalAbsencesFuturesFinDeContrat as ModalAbsencesFuturesFinDeContrat;
			if (this.modalAbsencesFuturesFinDeContrat != undefined && data.length > 0) {
				this.modalAbsencesFuturesFinDeContrat.continueProcess = () => {
					this.openFicheSalarie(idSalarie, titreOnglet);
				};

				this.modalAbsencesFuturesFinDeContrat.init(data);
			} else {
				this.openFicheSalarie(idSalarie, titreOnglet);
			}
		});
	}

	private openFicheSalarie(idSalarie: number, titreOnglet: string): void {
		EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });

		EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: titreOnglet } });
	}

	public submitButton(): void {
		if (!this.isValidHorairesPresence()) return;
		this.formSortieSalarie.trigger();

		setTimeout(() => {
			if (this.formSortieSalarie.checkSuccess()) {
				this.submit();
			} else {
				NotificationServiceInstance.SendFailed("Des erreurs sont présentes dans le formulaire.");
			}
		}, 1);
	}

	public submit(): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment soumettre cette sortie à validation ? Vous ne pourrez plus effectuer de changement !",
			callBackYes: () :void => {
				this.dataReady = false;

				this.setFormDataToSortieSalarie();

				if (this.sortieSalarie !== undefined) {
					if (this.sortieSalarie.Id <= 0) { // Un Ajout
						ServicesFactoryInstance.SortieSalarieService.addSortieSalarie(this.sortieSalarie, data => {
							if (this.sortieSalarie !== undefined) {
								this.sortieSalarie.Id = data.Id;
								this.currentId = data.Id;
							}

							this.saveHoraireHebdo();
							this.soumettreAValidation();
						}, () => this.dataReady = true);
					} else { // Une MAJ
						ServicesFactoryInstance.SortieSalarieService.updateSortieSalarie(this.sortieSalarie, () => {
							this.saveHoraireHebdo();
							this.soumettreAValidation();
						}, () => this.dataReady = true);
					}
				}
			}
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public soumettreAValidation(): void {
		ServicesFactoryInstance.SortieSalarieService.soumettreAValidation(this.currentId, () => {
			NotificationServiceInstance.SendSuccess("La sortie a été envoyée avec succès.");
			EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
		}, () => this.dataReady = true);
	}

	// On peut valider une sortie si état = A valider
	public canValider(): boolean {
		return formulaireEntreeSortieHelper.canValider(this.sortieSalarie != undefined ? this.sortieSalarie.EstSoumise : false, this.sortieSalarie != undefined ? this.sortieSalarie.EstValidee : false);
	}

	// On peut soumettre une sortie si état = en cours
	public canSoumettre(): boolean {
		return formulaireEntreeSortieHelper.canSoumettre(this.sortieSalarie != undefined ? this.sortieSalarie.EstSoumise : false, this.sortieSalarie != undefined ? this.sortieSalarie.EstValidee : false);
	}

	public setMotifDeDepartRequired(): void {
		if (ParametresInstance.listeMotifsPourDateNotificationRuptureObligatoire.filter(c => (c === this.dataForm.autreMotif.vmodel || c === this.dataForm.motifLicenciement.vmodel)).length > 0) {
			this.dataForm.dateNotif.required = true;
		} else {
			this.dataForm.dateNotif.required = false;
		}
	}

	/**
	 * Permet de définir si le formulaire est en lecture seule (readOnly) en fonction du rôle de l'utilisateur
	 */
	private setReadOnly(): void {
		let readOnly: boolean = true;

		if (!this.sortieSalarie?.EstValidee) {
			if (ParametresInstance.userHasRole(RoleConstants.Administrateur)) {
				// L'Admin peut modifier si le formulaire n'est pas validé
				readOnly = false;
			} else if (ParametresInstance.userHasRole(RoleConstants.AdministrateurPST) && this.sortieSalarie?.EstSoumise) {
				// L'AdminPST peut modifier si le formulaire est soumis et pas validé
				readOnly = false;
			} else if (ParametresInstance.userHasRole(RoleConstants.UtilisateurPST) && !this.sortieSalarie?.EstSoumise) {
				// L'UtilisateurPST peut modifier si le formulaire n'est pas soumis et pas validé
				readOnly = false;
			}
		}

		this.readOnly = readOnly;
	}
	
	private setDataFormDefault(): void {
		this.dataForm.salarie.vmodel = "";
		this.dataForm.heuresmois.vmodel = "";
		this.dataForm.transport.vmodel = "";
		this.dataForm.restaurant.vmodel = "";
		this.dataForm.cprestant.vmodel = "";
		this.dataForm.rttrestant.vmodel = "";
		this.dataForm.reglement.vmodel = "";
		this.dataForm.dateDepart.vmodel = "";
		this.dataForm.dateDernier.vmodel = "";
		this.dataForm.dateNotif.vmodel = "";
		this.dataForm.motif.vmodel = "";
		this.dataForm.divers.vmodel = "";
		this.dataForm.motifLicenciement.vmodel = "";
		this.dataForm.dateLicenciement.vmodel = "";
		this.dataForm.typePreavis.vmodel = "";
		this.dataForm.debutPreavis.vmodel = "";
		this.dataForm.finPreavis.vmodel = "";
		this.dataForm.montantIndemnite.vmodel = "";
		this.dataForm.dateSignature.vmodel = "";
		this.dataForm.autreMotif.vmodel = "";
		this.dataForm.refusCdiSuiteCdd.vmodel = "";
	}

	private setRefusCdiSuiteCddRequired(): void {
		const salarie = this.listeSalarie.filter(s => s.FullName == this.dataForm.salarie.display)[0] || null;
		if (salarie == null) {
			return;
		}

		if (salarie.NatureContrat != undefined && salarie.NatureContrat == "CDD") {
			this.dataForm.refusCdiSuiteCdd.required = true;
			this.dataForm.refusCdiSuiteCdd.disabled = false;
		} else {
			this.dataForm.refusCdiSuiteCdd.vmodel = "";
			this.dataForm.refusCdiSuiteCdd.required = false;
			this.dataForm.refusCdiSuiteCdd.disabled = true;
		}
	}

	/**
	 * @description Ouvre le modal pour modifier les horaires de présence
	 */
	public openHoraireHebdo(): void {
		const heures = this.heuresParSemaine();

		this.libelleHeuresPourModale = heures !== undefined
			? dateHelper.formatHeuresDecimales(heures?.toString())
			: undefined;
 
		this.horaireHebdoPourModale = this.horaireHebdo;
		this.showModalHoraireHebdo = true;
	}

	public onHoraireHebdoUpdated(horairesHebdoUpdated: HoraireHebdoDto): void {
		if (horairesHebdoUpdated !== null) {
			this.horaireHebdo = normaliserHoraireHebdoRecu(horairesHebdoUpdated);
		}
		const horairesErrors = this.validateHorairesPresence();
		if (horairesErrors.length > 0) {
			NotificationServiceInstance.SendWarningList(horairesErrors);
		}
		this.isModified = true;
	}

	private saveHoraireHebdo(): void {
		const idSalarie = Number(this.dataForm.salarie.vmodel);
		const idContrat = this.listeSalarie.find(s => s.Id === idSalarie)?.IdContrat;

		if (this.sortieSalarie === undefined || this.horaireHebdo === undefined || idSalarie === 0 || idContrat === undefined) {
			return;
		}

		ServicesFactoryInstance.HoraireHebdoService.addOrUpdateHoraireHebdoContrat(idContrat, this.horaireHebdo,
			(data) => {
				NotificationServiceInstance.SendSuccess("Le calendrier du salarié a été enregistré");
				this.horaireHebdo = data ? normaliserHoraireHebdoRecu(data) : undefined;
				this.majAffichageHorairesPresence();
			}, () => {
				NotificationServiceInstance.SendFailed("L'enregistrement du calendrier a échoué");
			}
		);
	}

	/**
	 * @description Vérifie si les horaires de présence sont valides et retourne les messages d'erreur.
	 * @returns Liste des messages d'erreur (hasHorairesError + erreur visuelle heures/semaine si échec).
	 */
	public validateHorairesPresence(): string[] {
		this.majAffichageHorairesPresence();

		if (!this.isTempsPartiel()) {
			this.hasHorairesError = false;
			return [];
		}

		const errors: string[] = [];

		if (!horairesHebdoSontRenseignes(this.horaireHebdo)) {
			errors.push("Les horaires de présence sont obligatoires pour ce contrat.");
		} else {
			const totalMinutes = totalMinutesHoraireHebdo(this.horaireHebdo);
			const cibleMinutes = decimalHeuresEnMinutes(Number(this.heuresParSemaine()));

			if (totalMinutes !== cibleMinutes) {
				errors.push(
					`Le total des horaires de présence (${formatMinutesAsHHmm(totalMinutes)}) doit correspondre aux heures par semaine (${formatMinutesAsHHmm(cibleMinutes)}).`
				);
			}
		}

		this.hasHorairesError = (errors.length > 0);

		return errors;
	}

	/**
	 * @description Récupère les horaires hebdo du contrat spécifié
	 */
	private retrieveSalarieInfo(): void {
		this.horaireHebdo = undefined;
		this.horaireHebdoPourModale = undefined;
		this.dataReady = false;
		this.hasHorairesError = false;
		this.heuresMensuellesContrat = undefined;

		const idSalarie = Number(this.dataForm.salarie.vmodel)
		const idContrat = this.listeSalarie.find(s => s.Id === idSalarie)?.IdContrat;

		if (idSalarie === 0 || idContrat === undefined) {
			this.dataReady = true;
			return;
		}

		// Récupérer les HoraireHebdo du contrat
		ServicesFactoryInstance.HoraireHebdoService.getHoraireHebdoContrat(idContrat,
			(horaires) => {
				this.horaireHebdo = horaires ? normaliserHoraireHebdoRecu(horaires) : undefined;

				// Récupérer les HeuresMensuelles du contrat
				ServicesFactoryInstance.SalarieService.getSalarieQualificationForContrat(idSalarie, idContrat,
					(salarieCourant) => {
						const paramRubrique027 = ParametresInstance.listeRubriques.find(
							(r) => r.CodeRubrique === "027" && r.CodeNature === "S"
						);
						this.heuresMensuellesContrat = paramRubrique027
							? salarieCourant.RubriqueContrats.find(
								(x) => x.IdRubriqueFk == paramRubrique027.Id
							)?.Value
							: undefined;

						this.majAffichageHorairesPresence();
						this.dataReady = true;
					}
				);

			}, _ => {
				this.dataReady = true;
			}
		);
	}

	/**
	 * @description Vérifie si le contrat est à temps partiel
	 */
	public isTempsPartiel(): boolean {
		const IdSalarie = Number(this.dataForm.salarie.vmodel);
		const salarie = this.listeSalarie.find(s => s.Id === IdSalarie);
		return salarie?.TempsTravail == "Temps partiel" ||
			(this.heuresMensuellesContrat != undefined && this.heuresMensuellesContrat < 151.67);
	}

	/**
	 * @description Met à jour le libellé du champ et l'état d'alerte
	 */
	private majAffichageHorairesPresence(): void {
		this.horairesPresenceLibelle = libelleAffichageHorairesPresence(this.horaireHebdo);
		this.showHorairesPresenceAlerte = this.isTempsPartiel() && !horairesHebdoSontRenseignes(this.horaireHebdo);
	}

	/**
	 * @description Vérifie si les horaires de présence sont valides et affiche une notification si ce n'est pas le cas
	 * @returns true si les horaires de présence sont valides, false sinon
	 */
	private isValidHorairesPresence(): boolean {
		const horairesErrors = this.validateHorairesPresence();
		if (horairesErrors.length > 0) {
			NotificationServiceInstance.SendFailedList(horairesErrors);
			return false;
		}

		return true;
	}

	private heuresParSemaine(): number | undefined {
		if (this.heuresMensuellesContrat === undefined || isNaN(this.heuresMensuellesContrat)) return undefined
		return Math.round((this.heuresMensuellesContrat / 52 * 12) * 100) / 100; // Arrondi à 2 décimales
	}

	public get horairesPresenceRenseignes(): boolean {
		return horairesHebdoSontRenseignes(this.horaireHebdo);
	}

	public get hasSalarieSelected(): boolean {
		return this.dataForm.salarie.vmodel !== "";
	}
}



// WEBPACK FOOTER //
// ./src/components/sortieSalarie/sortieSalarie.ts